import { IViewerStore } from '../store/viewer/viewer.store';

export function calculateZoomForFillToView(originalPageWidth?: number) {
  const DEFAULT_FIT_ZOOM = 75;

  if (!originalPageWidth) {
    return DEFAULT_FIT_ZOOM;
  }

  const width = document.documentElement.clientWidth;

  return (width / originalPageWidth) * 100;
}

export function calculateZoomForFitToView(pageDimension?: IViewerStore['pageDimension']) {
  const DEFAULT_FIT_ZOOM = 75;

  if (!pageDimension) {
    return DEFAULT_FIT_ZOOM;
  }

  const { innerWidth: width, innerHeight: height } = window;

  const calculatedFitHeightRatioBasedOnScreenHeight = height / pageDimension.height;
  const calculatedFitWidthRatioBasedOnScreenWidth = width / pageDimension.width;

  const fitZoomValueBaesedOnHeightAndWidth = Math.min(
    calculatedFitHeightRatioBasedOnScreenHeight,
    calculatedFitWidthRatioBasedOnScreenWidth
  );

  return fitZoomValueBaesedOnHeightAndWidth * 100;
}
